export const Ornament = ({ className = "" }) => (
  <svg viewBox="0 0 120 20" className={className} fill="none" aria-hidden="true">
    <path d="M0 10 H40" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <path d="M80 10 H120" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    <path
      d="M60 2 C64 6 66 8 72 10 C66 12 64 14 60 18 C56 14 54 12 48 10 C54 8 56 6 60 2 Z"
      fill="currentColor"
      opacity="0.85"
    />
    <circle cx="44" cy="10" r="1.6" fill="currentColor" />
    <circle cx="76" cy="10" r="1.6" fill="currentColor" />
  </svg>
);

export const CornerFlourish = ({ className = "" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <path d="M2 2 H20 M2 2 V20" stroke="currentColor" strokeWidth="1.5" />
    <path d="M6 6 C16 6 16 16 6 16 M6 6 C6 16 16 16 16 6" stroke="currentColor" strokeWidth="1" opacity="0.7" />
  </svg>
);
